'use client'

import type { PropsWithChildren } from 'react'
import { SignedIn, SignedOut } from '@steelhouse/auth-next/client'

import { SessionProvider } from '@mntn-dev/session/frontend'
import type { AuthorizedSession } from '@mntn-dev/session/types'
import { CenteredLayout } from '@mntn-dev/ui-components/centered-layout'
import { LoadingCenter } from '@mntn-dev/ui-components/loading'

import { redirectToSignIn } from './redirect-to-sign-in.ts'

const SignedOutRedirect = () => {
  redirectToSignIn({
    redirect_url:
      typeof window !== 'undefined' ? window.location.href : undefined,
  })

  return (
    <CenteredLayout>
      <LoadingCenter />
    </CenteredLayout>
  )
}

export const AuthenticationBoundary = ({
  session,
  children,
}: PropsWithChildren<{ session: AuthorizedSession }>) => {
  return (
    <>
      <SignedIn>
        <SessionProvider session={session}>{children}</SessionProvider>
      </SignedIn>
      <SignedOut>
        <SignedOutRedirect />
      </SignedOut>
    </>
  )
}
